<app-pathway-guided-result
  *ngIf="isEmbeddedInQuizResult"
  [resultReady]="resultReady"
  [translationLoaded]="translationLoaded"
  [guidedResults]="guidedResults"
  [criteriaScore]="criteriaScore"
  [embeddedStepsToReview]="embeddedStepsToReview"
  [hasPassed]="hasPassed()"
></app-pathway-guided-result>

<!-- Standard mode: full results page -->
<ng-container *ngIf="!isEmbeddedInQuizResult">

<div class="hang-tight-screen" *ngIf="!resultReady && translationLoaded">
  <app-hang-tight [isErrorLoadingScreen]="isErrorLoadingScreen"
    [displayButtonLoadingScreen]="displayButtonLoadingScreen" [titleLoadingScreen]="titleLoadingScreen"
    [messageLoadingScreen]="messageLoadingScreen">
  </app-hang-tight>
</div>

<ng-container *ngIf="resultReady && translationLoaded">
  <div class="header-outer">
    <qai-inner-wrap class="header-inner">
      <!-- Top call title and date -->
      <div class="header-breadcrumbs">
        <qai-breadcrumb-list class="breadcrumbs-list" [items]="getBreadcrumbs" />

        <div class="date">
          <mat-select data-testId="practiceCallTimes" id="practiceCallTimes" hasBackdrop="true"
            (selectionChange)="onSelectedPracticeTime($event)" [value]="practiceCallUuid">
            <mat-option *ngFor="let call of practiceCallResults; let i = index" [value]="call.practiceCallUuid"
              [attr.data-testId]="'practiceCallTime-' + i">
              <qai-label [size]="'small'">
                {{ call.attemptDate}}
              </qai-label>
            </mat-option>
          </mat-select>
        </div>
      </div>

      <h1 class="header-title">
        {{ guidedResults!.callName }}
      </h1>
      <p *ngIf="showLegalDisclaimer && disclaimerText" class="header-legal-disclaimer">
        {{ disclaimerText }}
      </p>
    </qai-inner-wrap>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <mat-tab-group class="tabs" mat-stretch-tabs="false" (selectedTabChange)="tabClick($event.index)" animationDuration="0ms">

      <!-- Always show Results tab -->
      <mat-tab label="{{ 'results.CALL_RESULTS' | transloco }}">
        <ng-container *ngTemplateOutlet="resultsContent"></ng-container>
      </mat-tab>

      <!-- Skills tab: only for compliant users -->
      <mat-tab *ngIf="isUserCompliant && showSkillResults && !isPathwayFlow" label="{{ 'results.SKILLS' | transloco }}">
        <app-results-skills
          [practiceCallUuid]="guidedResults!.practiceCall.uuid"
          [scoredAt]="guidedResults!.practiceCall.scoredAt">
        </app-results-skills>
      </mat-tab>

      <!-- Transcript tab: optional depending on spec -->
      <mat-tab *ngIf="isUserCompliant && showTranscription && !isPathwayFlow" label="{{ 'results.TRANSCRIPT_LABEL' | transloco }}">
        <qai-inner-wrap class="body">
          <app-results-transcript
            [practiceCallUuid]="guidedResults!.practiceCall.uuid"
            [transcriptTab]="true"
            [showFooter]="false"
            [callType]="guidedResults?.callType"
            [practiceType]="practiceType">
          </app-results-transcript>
        </qai-inner-wrap>
      </mat-tab>

    </mat-tab-group>

  </div>

  <!-- Session ID -->
  <div class="footer">
    <qai-inner-wrap class="session-id">
      <div class="text" (click)="copyText()" [matMenuTriggerFor]="tooltipMenu">
        {{'results.SESSION_ID' | transloco}} {{ guidedResults!.practiceCall.uuid }}
      </div>
      <mat-menu #tooltipMenu="matMenu" yPosition="above" hasBackdrop="false" class="tooltip-copy-session-id">
        <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
      </mat-menu>
    </qai-inner-wrap>
  </div>

    <!-- Footer -->
    <app-footer></app-footer>
  </ng-container>

</ng-container>

<ng-template #resultsContent>
  <!-- Score -->
  <div class="hero">
    <qai-inner-wrap class="hero-wrap">

      <!-- Score -->
      <div class="header-content-score">
        <div *ngIf="isUserCompliant" class="score-square" [ngClass]="{
            success: criteriaScore > 0 && practiceScore >= criteriaScore,
            default: practiceType === typePractice && criteriaScore <= 0
          }">
          <div class="title">{{'results.YOUR_SCORE' | transloco}}</div>
          <div class="score">{{ callScoreCalcType === calcTypeRatio5pt0min ? (practiceScore | number : '1.1-2') : (callScoreCalcType === 'RATIO_100PT_0MIN' ? (practiceScore | number : '1.0-2') + '%' : (practiceScore | number : '1.0-2')) }}</div>
          <div class="sub-title">{{ callScoreCalcType === 'RATIO_100PT_0MIN' ? ('results.OUT_OF_100' | transloco) : ('results.OUT_OF_5' | transloco) }}</div>
        </div>

        <div *ngIf="!isUserCompliant" class="score-square warning">
          <div class="title">{{'results.YOUR_SCORE' | transloco}}</div>
          <div class="score">{{'results.OUT_OF_COMPLIANCE' | transloco}}</div>
        </div>
      </div>

      <div class="header-content-title">
        <!-- Practice Type -->
        <ng-container *ngIf="
            practiceType === typePractice && criteriaScore <= 0;
            else certificationType
          ">
          <ng-container *ngIf="isUserCompliant">
            <ng-container *ngIf="practiceScore >= 0 && practiceScore <= 3">
              <h2 class="title">{{'results.TRY_AGAIN_MESSAGE' | transloco}}</h2>
              <p class="sub-title">
                {{'results.PRACTICE_BENEFITS' | transloco}}
              </p>
            </ng-container>
            <ng-container *ngIf="practiceScore > 3 && practiceScore <= 5">
              <h2 class="title">
                {{'results.CALL_SUCCESS' | transloco}}
              </h2>
              <p class="sub-title">
                {{'results.PRACTICE_BENEFITS' | transloco}}
              </p>
            </ng-container>
            @if (assignment?.status?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS.toLowerCase()) {
              <button qai-button [kind]="'primary'" [size]="'large'" [disabled]="isMaxAttemptsReached"
                (click)="navigateToRoute()"
                [matTooltip]="isMaxAttemptsReached ? ('results.MAX_ATTEMPTS_REACHED' | transloco) : ''"
                matTooltipClass="tooltip-dark">
                {{'results.TRY_AGAIN' | transloco}}
              </button>
            }
          </ng-container>
          <!-- User not compliant -->
          <ng-container *ngIf="!isUserCompliant && isMaxAttemptsReached">
            <div class="title">{{'results.YOU_ARE_OUT_OF_ATTEMPTS' | transloco}}</div>
            <span class="title-normal">{{'results.REVIEW_GUIDELINES_REMAIN_COMPLIANT' | transloco}}</span>
          </ng-container>
          <ng-container *ngIf="!isUserCompliant && !isMaxAttemptsReached">
            <div class="title">{{'results.TRY_AGAIN_ATTENTION_TO_COMPLIANCE' | transloco}}</div>
            @if (assignment?.status?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS.toLowerCase()) {
              <button qai-button [kind]="'primary'" [size]="'large'" (click)="navigateToRoute()">
                {{'results.TRY_AGAIN' | transloco}}
              </button>
            }
          </ng-container>
        </ng-container>
        <!-- Certification Type -->
        <ng-template #certificationType>
          <!-- User Compliant && Score success -->
          <ng-container *ngIf="isUserCompliant">
            <ng-container *ngIf="practiceScore >= criteriaScore">
              <div class="title">
                {{'results.CALL_SUCCESS' | transloco}}
              </div>
              <div class="sub-title">
                {{'results.ACHIEVED_SCORE' | transloco}} {{ callScoreCalcType === 'RATIO_100PT_0MIN' ? criteriaScore + '%' : criteriaScore }} {{'results.OR_HIGHER' | transloco}}
              </div>
              <button qai-button [kind]="'primary'" size="large" (click)="navigateToRoute()">
                {{returnButtonLabel}}
              </button>
            </ng-container>
            <!-- Low score -->
            <ng-container *ngIf="practiceScore < criteriaScore">
              <div class="title">{{'results.TRY_AGAIN_MESSAGE' | transloco}}</div>
              <div class="sub-title">
                {{'results.ACHIEVE_SCORE' | transloco}} {{ callScoreCalcType === 'RATIO_100PT_0MIN' ? criteriaScore + '%' : criteriaScore }} {{'results.OR_HIGHER' | transloco}}
              </div>
              @if (assignment?.status?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS.toLowerCase()) {
                <button qai-button [kind]="'primary'" [size]="'large'"
                  [disabled]="isMaxAttemptsReached"
                  (click)="navigateToRoute()"
                  [matTooltip]="isMaxAttemptsReached ? ('results.MAX_ATTEMPTS_REACHED' | transloco) : ''"
                  matTooltipClass="tooltip-dark">
                  {{ practiceType === AppConstants.TYPE_PATHWAY ? ('results.RETURN_TO_PATHWAY' | transloco) : ('results.TRY_AGAIN' | transloco) }}
                </button>
              }
            </ng-container>
          </ng-container>
          <!-- Compliance Call and User not compliant -->
          <ng-container *ngIf="!isUserCompliant && isMaxAttemptsReached">
            <div>
              <div class="title">{{'results.YOU_ARE_OUT_OF_ATTEMPTS' | transloco}}</div>
              <span class="title-normal"> {{'results.REVIEW_GUIDELINES_REMAIN_COMPLIANT' | transloco}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="!isUserCompliant && !isMaxAttemptsReached">
            <div class="title">{{'results.TRY_AGAIN_ATTENTION_TO_COMPLIANCE' | transloco}}</div>
            @if (assignment?.status?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS.toLowerCase()) {
              <button qai-button [kind]="'primary'" [size]="'large'" (click)="navigateToRoute()">
                {{'results.TRY_AGAIN' | transloco}}
              </button>
            }
          </ng-container>
        </ng-template>
      </div>



    </qai-inner-wrap>
  </div>

  <!-- Feedback Content -->
  <div *ngIf="isUserCompliant" class="feedback">
    <qai-inner-wrap class="content">
      <h2 class="section-heading">{{'results.CALL_FEEDBACK' | transloco}}</h2>
      <!-- Answers feedback -->
      <div class="questions">
        <div class="question-result" *ngFor="let question of guidedResults?.questions">
          <div class="question">
            {{ question.name }}
          </div>
          <!-- User answer -->
          <div class="accordion" *ngIf="guidedResults?.practiceCall?.displayTranscription">
            <div class="accordion-header" (click)="
                question.isUserResponseExpanded =
                  !question.isUserResponseExpanded
              ">
              <div class="accordion-title">{{'results.YOUR_RESPONSE' | transloco}}</div>
              <img src="/assets/icons/minus.svg" [alt]="'results.MINUS' | transloco"
                *ngIf="question.isUserResponseExpanded" />
              <img src="/assets/icons/plus.svg" [alt]="'results.PLUS' | transloco"
                *ngIf="!question.isUserResponseExpanded" />
            </div>
            <div class="accordion-content" [class.display]="question.isUserResponseExpanded">
              <br />
              {{ question.practiceCallGuided.cleanedUserResponse }}
            </div>
          </div>

          <!-- Recommended response -->
          <div class="accordion" *ngIf="question.suggestions && showMissedFacts">
            <div class="accordion-header" (click)="
                question.isRecommendedResponseExpanded =
                  !question.isRecommendedResponseExpanded
              ">

              <div class="accordion-title">{{'results.RECOMMENDED_RESPONSE' | transloco}}</div>

              <img src="/assets/icons/minus.svg" [alt]="'results.MINUS' | transloco"
                *ngIf="question.isRecommendedResponseExpanded" />
              <img src="/assets/icons/plus.svg" [alt]="'results.PLUS' | transloco"
                *ngIf="!question.isRecommendedResponseExpanded" />
            </div>
            <div class="accordion-content" [class.display]="question.isRecommendedResponseExpanded">
              <br />
              {{ question.suggestions }}
            </div>
          </div>

          <div class="separator" *ngIf="
              question.suggestions ||
              guidedResults?.practiceCall?.displayTranscription
            "></div>

          <div class="talking-points">
            <!-- Covered -->
            <div class="talking-point">
              <div class="talking-point-title covered">{{'results.TALKING_POINTS_COVERED' | transloco}}</div>
              <div class="points">
                <!-- Points list -->
                <div class="points-list" *ngIf="
                    question.practiceCallGuided.positiveContext.length > 0;
                    else emptyPositiveContext
                  ">
                  <div class="point" *ngFor="
                      let point of question.practiceCallGuided.positiveContext
                    ">
                    <img src="/assets/icons/check-2.svg" [alt]="'results.CHECKMARK_ICON_ALT' | transloco" />
                    {{ point }}
                  </div>
                </div>
                <!-- Message, didn't cover all points -->
                <ng-template #emptyPositiveContext>
                  <div class="message">
                    <strong>{{'results.REVIEW_MISSED_TITLE' | transloco}}</strong> {{'results.NO_TALKING_POINTS_COVERED'
                    | transloco}}
                  </div>
                </ng-template>
              </div>
            </div>
            <!-- Missed -->
            <div class="talking-point">
              <div class="talking-point-title missed">
                {{
                visualAid
                ? ('results.TALKING_POINT_TITLE' | transloco)
                : ('results.TALKING_POINTS_MISSED' | transloco)
                }}
              </div>
              <div class="points">
                <!-- Points list -->
                <div class="points-list" *ngIf="
                    question.practiceCallGuided.negativeContext.length > 0;
                    else emptyNegativeContext
                  ">
                  <div class="point" *ngFor="
                      let point of question.practiceCallGuided.negativeContext
                    ">
                    <img src="/assets/icons/x-error.svg" [alt]="'results.X_ICON_ALT' | transloco" />

                    <!-- Underscore / hidden point -->
                    <div class="underscore-list" *ngIf="isTextUnderscore(point); else normalPoint">
                      <span *ngFor="let char of point.split(' ')" class="underscore"
                        [style.width.px]="char.length * 10"></span>
                    </div>
                    <!-- Normal point -->
                    <ng-template #normalPoint>
                      <div [ngClass]="{ 'hide-talking-points': !showMissedFacts }">
                        {{ showMissedFacts ? point : "" }}
                      </div>
                    </ng-template>
                  </div>
                </div>
                <!-- Resource reference (only if are points missed) -->
                <qai-alert class="resource" kind="hint" [title]="'results.LEARN_WHAT_YOU_MISSED' | transloco" *ngIf="
                    question.practiceCallGuided.negativeContext.length > 0 &&
                    question.reference
                  ">
                  <div [innerHTML]="question.reference"></div>
                </qai-alert>

                <!-- Message, covered all points -->
                <ng-template #emptyNegativeContext>
                  <div class="message">
                    <strong>{{'results.NICE_JOB' | transloco}}</strong> {{'results.ALL_POINTS_COVERED' | transloco}}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </qai-inner-wrap>
  </div>


  <!-- Feedback for non compliant Content -->
  <div *ngIf="!isUserCompliant" class="feedback">
    <qai-inner-wrap class="content">
      <!-- Answers feedback -->
      <div class="questions">
        <div class="question-result">
          <div class="question out-of-compliance">{{'results.NO_SCORE_OUT_OF_COMPLIANCE' | transloco}}</div>

          <div class="talking-points">
            <!-- Missed -->
            <div class="talking-point">
              <div class="talking-point-title missed">
                {{'results.WHY_OUT_OF_COMPLIANCE' | transloco}}
              </div>
              <div class="talking-point-subtitle">
                {{'results.REVIEW_MISSED_GUIDELINES' | transloco}}
              </div>
              <div class="points">
                <!-- Points list -->
                <div class="points-list">
                  <ng-container *ngFor="let section of complianceScoringResult?.sections">
                    <ng-container *ngFor="let fact of section.facts">
                      <div class="point" *ngIf="fact.correct === 0">
                        <img src="assets/icons/exclamation-red.svg" [alt]="'results.X_ICON_ALT' | transloco" />
                        <div>
                          {{fact.factText}}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </qai-inner-wrap>
  </div>


  <!-- Feedback for non compliant Content -->
  <div *ngIf="complianceScoringResult && anyCorrectFact" class="feedback">
    <qai-inner-wrap class="content">

      <!-- Answers feedback -->
      <div class="questions">
        <div class="question-result">
          <div class="question compliance-followed">
            <div class="question-name-thumbnail">
              <span>
                {{'results.COMPLIANCE_GUIDELINES' | transloco}}
              </span>
            </div>
            <div class="point-collapser">
              <img (click)="isExpandedd = !isExpandedd"
                [src]="isExpandedd ? 'assets/icons/arrow/chevron-down-blue1.svg' : 'assets/icons/arrow/chevron-left-blue.svg'">
            </div>
          </div>

          <div class="talking-points" *ngIf="isExpandedd">
            <!-- Covered -->
            <div class="talking-point">
              <div class="talking-point-title covered">{{'results.WHAT_YOU_DID_WELL' | transloco}}</div>
              <div class="talking-point-subtitle">
                {{'results.YOU_DID_FOLLOW_GUIDELINES' | transloco}}
              </div>
              <div class="points">
                <!-- Points list -->
                <div class="points-list">
                  <ng-container *ngFor="let section of complianceScoringResult?.sections">
                    <ng-container *ngFor="let fact of section.facts">
                      <div class="point" *ngIf="fact.correct === 1">
                        <img src="/assets/icons/check-2.svg" alt="checkmark" />
                        <div>
                          {{fact.factText}}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </qai-inner-wrap>
  </div>
</ng-template>
